
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiBuoyCanBoard as ObiBuoyCanBoardElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-buoy-can-board.js';
 
 
 

 
 export const ObiBuoyCanBoard = createComponent({
   react: React,
   tagName: 'obi-buoy-can-board',
   elementClass: ObiBuoyCanBoardElement,
   events: {
     
   }
  });
 
 